<details-sphere v-if="options" :sphere="options" :submitted="submitted" :can-delete="false"/>
